import React, { useState, useEffect } from 'react';

import ServiceOverview from 'services/serviceOverview';

export default function ComponentListPMode(props) {

    const overviewService = new ServiceOverview();

    const [chartData, setChartData] = useState([
        { pmode: "Cash", total: 0 },
        { pmode: "UPI", total: 0 },
        { pmode: "Card", total: 0 },
        { pmode: "Bank", total: 0 },
        { pmode: "NC", total: 0 },
        { pmode: "chq", total: 0 },
    ]);

    const [loading, setLoading] = useState(true);

    const chartConfig = {
        total: {
            label: "Total",
            color: "#2563eb",
        },
    }

    const loadData = () => {
        (async function () {
            if (props.range !== undefined && props.range.from !== undefined && props.range.to !== undefined) {
                let body = {
                    "startDate": props.range.from.toISOString(),
                    "endDate": props.range.to.toISOString(),
                }
                var res = await overviewService.getCharData(body, '');
                setChartData(res.data);
            }
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, [props.range]);

    return (
        <div className='col-span-4'>
            <div className="shadow bg-white rounded-lg p-4">
                <div className='flex items-center justify-between'>
                    <h3 className='text-lg font-sans font-medium'>Sales | Payment Mode</h3>
                </div>
                <hr className='my-2' />
                <div className='grid grid-cols-2 gap-1 m-1'>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">Cash</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[0]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">UPI</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[1]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-1 m-1'>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">BANK</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[2]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">Card</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[3]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-1 m-1'>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">NC</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[5]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                    <div className="rounded-xl border bg-card text-card-foreground shadow col-span-1">
                        <div className="p-4 flex flex-row items-center justify-between space-y-0 pb-2">
                            <div className="tracking-tight text-sm font-medium">OTHER</div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="text-2xl font-bold text-blue-600">₹ {(chartData[4]['total']).toFixed(2)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
